









































































































































































































































































































































































































































































import { Component, Vue, Provide, Prop } from "vue-property-decorator";
import {
  GetOverdueListReq,
  GetOverdueListParamReq,
  GetRemindListReq,
} from "@/pbjs/xcommon/collection_pb.js";
import { collectionServiceClient } from "@/api";
import { localGet, timeFormat } from "@/utils";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, errorMsg, setPage } from "@/utils/request";
//import { setPage } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";

@Component({
  name: "newOrder",
  filters: {
    filterTime(time: number) {
      function addZero(val: any) {
        if (val < 10) {
          val = "0" + val;
        }
        return val;
      }
      if (!time) {
        return time;
      }
      let date: any = new Date(time);
      let month: any = addZero(date.getMonth() + 1);
      let day: any = addZero(date.getDate());
      var yearMonthDay = date.getFullYear() + "-" + month + "-" + day;
      var hoursMS =
        addZero(date.getHours()) +
        ":" +
        addZero(date.getMinutes()) +
        ":" +
        addZero(date.getSeconds());
      return yearMonthDay + " " + hoursMS;
    },
  },
})
export default class CombinationProperty extends Vue {
  @Provide() private propList: any = []; // list
  @Provide() private token: any = ""; // token
  @Provide() private pageSize: any = 20; //分页页数
  @Provide() private pagerCount: any = 0; //总条数
  @Provide() private pageIndex: any = 1; //当前页
  @Provide() private ticketId: any = ""; //工单ID
  @Provide() private orderId: any = ""; //借款ID
  @Provide() private overdueDays1: any = ""; //逾期天数
  @Provide() private overdueDays2: any = ""; //逾期天数
  @Provide() private mobile: any = ""; //电话
  @Provide() private TicketTag: any = null; //电话
  @Provide() private FirstsubsequentLoan: any = null; //首复贷
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private systemInfo: any = localStorage.getItem("systemInfo"); // 国家，字段差异化展示
  @Provide() private userId: any = ""; //userId
  @Provide() private completeTimePicker: any = []; // 完成时间
  @Provide() private TicketTagMapOptions: any = []; // 印度业务线下拉选项
  @Provide() private preStatusOptions: any = []; // 墨西哥nanopay预完成状态下拉选项
  @Provide() private isGetListActionDone: boolean = false;
  @Provide() private showreloan: boolean = false;
  @Provide() private machineCollection: any = null;
  @Provide() private pagnition: any = pagnition;
  @Provide() private roll: any = "";
  @Provide() private preStatus: any = [];
  @Provide() private AppOpnList: any = [];
  @Provide() private AppName: any = "";
  @Provide() private machineCollectionOptions: any = [
    { value: 1, name: "dashbordDy.yes" },
    { value: 2, name: "dashbordDy.no" },
  ];
  @Provide() private FirstsubsequentLoanOptions: any = [
    { value: 1, name: "v0707.FirstLoan" },
    { value: 2, name: "v0707.Reloan" },
    { value: 0, name: "ticketLgy.All" },
  ];
  @Provide() private rollOptions: any = [
    { name: "Normal Ticket", value: "2" },
    { name: "Extension Ticket", value: "1" },
  ];
  @Prop() type!: string;
  @Prop() page!: string;
  @Provide() private sortCondition: any = {
    prop: null,
    order: null,
  };

  private goDetail(row: any) {
    let routeData: any = this.$router.resolve({
      path: "collectionDetail",
      query: {
        id: row.ticket.relatedid,
        type: this.page,
        orderId: row.ticket.orderid,
      },
    });
    window.open(routeData.href, "_blank");
  }
  private tableRowClassName(scope: any) {
    if (scope.row.dailyhandlenum > 0) {
      return "purple-background";
    } else {
      return "";
    }
  }

  private sortChange(val: any) {
    switch (val.prop) {
      case "conumber":
        this.sortCondition.prop = Sort.SORT_BY_HANDLE_NUM;
        break;
      case "isreloan":
        this.sortCondition.prop = Sort.SORT_BY_CUSTOMER_TYPE;
        break;
      case "lastcotime":
        this.sortCondition.prop = Sort.SORT_BY_LAST_HANDLE_TIME;
        break;
      case "partialCompleteTime":
        this.sortCondition.prop = Sort.SORT_BY_PARTIAL_COMPLETE_TIME;
        break;
      case "nexthandletime":
        this.sortCondition.prop = Sort.SORT_BY_PROMISE_REPAY_TIME;
        break;
      case "ticket.remainamount":
        this.sortCondition.prop = Sort.SORT_BY_REMAIN_AMOUNT;
        break;
      case "overdueday":
        this.sortCondition.prop = Sort.SORT_BY_OVERDUE_DAY;
        break;
      default:
        this.sortCondition.prop = Sort.SORT_UNSPECIFIED;
        break;
    }
    switch (val.order) {
      case "descending":
        this.sortCondition.order = Rank.RANK_DESC;
        break;
      case "ascending":
        this.sortCondition.order = Rank.RANK_ASC;
        break;
      default:
        this.sortCondition.order = Rank.RANK_UNSPECIFIED;
        break;
    }
    this.getList();
  }

  private created() {
    this.userId = localStorage.getItem("userid");
    
  }
  private inputFuction(e: any, type: string) {
    switch (type) {
      case "overdueDays1":
        if (this.overdueDays1.length) {
          if (this.overdueDays1[0] == "-") {
            this.overdueDays1 = "-" + e.replace(/[^0-9]/g, "");
            if (this.overdueDays1.length > 5) {
              this.overdueDays1 = this.overdueDays1.substring(0, 5);
            }
          } else {
            this.overdueDays1 = e.replace(/[^0-9]/g, "");
            if (this.overdueDays1.length > 4) {
              this.overdueDays1 = this.overdueDays1.substring(0, 4);
            }
          }
        }
        break;
      case "overdueDays2":
        if (this.overdueDays2.length) {
          if (this.overdueDays2[0] == "-") {
            this.overdueDays2 = "-" + e.replace(/[^0-9]/g, "");
            if (this.overdueDays2.length > 5) {
              this.overdueDays2 = this.overdueDays2.substring(0, 5);
            }
          } else {
            this.overdueDays2 = e.replace(/[^0-9]/g, "");
            if (this.overdueDays2.length > 4) {
              this.overdueDays2 = this.overdueDays2.substring(0, 4);
            }
          }
        }
        break;
    }
  }
  private testOverdueday() {
    if (this.overdueDays1) {
      if (Number(this.overdueDays2) < Number(this.overdueDays1)) {
        this.$message(this.$tc("dashbordDy.Pleaseentervaliddays"));
        this.isGetListActionDone = false;
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
  private getCollectionListFuc(data: any) {
    data.listList.forEach((item: any) => {
      item.ticket.isstage =
        item.ticket.isstage == 0
          ? this.$t("Single payment")
          : this.$t("Partial payment");
      item.isreloan =
        item.isreloan == 0
          ? this.$t("v0707.FirstLoan")
          : this.$t("v0707.Reloan");
      item.nexthandletime =
        item.nexthandletime == "0" ? "-" : timeFormat(item.nexthandletime);
      item.isrobot =
        item.isrobot == 1
          ? this.$t("dashbordDy.yes")
          : item.isrobot == 2
          ? this.$t("dashbordDy.no")
          : "-";
    });
    this.showreloan = data.showreloan;

    this.propList = data.listList;
    this.pagerCount = data.pageout.total;
  }
  private getCollectionListParamFuc(data: any) {
    this.TicketTagMapOptions = data.tickettagmapMap;
    this.preStatusOptions = data.prestatusmapMap;
    let AppOpnList=JSON.parse(data.applist)
     Object.keys(AppOpnList).forEach((item:any) => {
       this.AppOpnList.push({
         codeName: AppOpnList[item], code: null, channel: item
       })
     });
  }
  private getCollectionListParam() {
    const getOrderListParamReq: any = new GetOverdueListParamReq();
    getOrderListParamReq.setCommonin(setCommon());
    collectionServiceClient.getOverdueListParam(
      getOrderListParamReq,
      {},
      (err: any, response: any) => {
        if (response) {
          const data: any = response.toObject();
          let _fuc = this.getCollectionListParamFuc;
          handleResponse(data, _fuc);
        }
        if (err) {
          errorMsg(err);
        }
        this.isGetListActionDone = false;
      }
    );
  }
  private getCollectionList() {
    if (this.testOverdueday()) {
      const getOrderListReq: any = new GetOverdueListReq();
      getOrderListReq.setCommonin(setCommon());
      getOrderListReq.setAction(this.type);
      getOrderListReq.setTicketid(Number(this.ticketId));
      getOrderListReq.setOrderid(this.orderId + "");
      getOrderListReq.setMobile(this.mobile + "");
      getOrderListReq.setIsrobot(Number(this.machineCollection));
      getOrderListReq.setTickettag(+this.TicketTag);
      getOrderListReq.setPrestatusList(this.preStatus.join());
      getOrderListReq.setIsreloan(Number(this.FirstsubsequentLoan));
      getOrderListReq.setOverdueday(
        this.overdueDays1 ? this.overdueDays1 + "~" + this.overdueDays2 : ""
      );
      getOrderListReq.setIsroll(+this.roll);
      if (this.completeTimePicker && this.completeTimePicker[0]) {
        getOrderListReq.setCompletetimerange(
          timeFormat(this.completeTimePicker[0]) +
            " - " +
            timeFormat(this.completeTimePicker[1])
        );
      }
      getOrderListReq.setPagein(
        setPage(
          this.pageIndex,
          this.pageSize,
          this.sortCondition.prop,
          this.sortCondition.order
        )
      );
      let AppName:string;
        this.AppOpnList.forEach((item:any) => {
          if (item.channel==this.AppName) {
            AppName=item.channel
          }
        }); 
      getOrderListReq.setAppname(AppName);
      collectionServiceClient.getOverdueList(
        getOrderListReq,
        {},
        (err: any, response: any) => {
          if (response) {

            const data: any = response.toObject();
            let _fuc = this.getCollectionListFuc;
            handleResponse(data, _fuc);
          }
          if (err) {
            errorMsg(err);
          }
          this.isGetListActionDone = false;
        }
      );
    }
  }

  private getRemindListFuc(data: any) {
    data.listList.forEach((item: any) => {
      item.ticket.isstage =
        item.ticket.isstage == 0
          ? this.$t("Single payment")
          : this.$t("Partial payment");
      item.isreloan =
        item.isreloan == 0
          ? this.$t("v0707.FirstLoan")
          : this.$t("v0707.Reloan");
      item.isrobot =
        item.ticket.isrobot == 1
          ? this.$t("dashbordDy.yes")
          : item.ticket.isrobot == 2
          ? this.$t("dashbordDy.no")
          : "-";
    });
    this.showreloan = data.showreloan;
    this.propList = data.listList;
    this.pagerCount = data.pageout.total;
  }
  private getRemindList() {
    const getOrderListReq: any = new GetRemindListReq();
    getOrderListReq.setCommonin(setCommon());
    getOrderListReq.setAction(this.type);
    getOrderListReq.setTicketid(Number(this.ticketId));
    getOrderListReq.setOrderid(this.orderId + "");
    getOrderListReq.setMobile(this.mobile + "");
    getOrderListReq.setTickettag(+this.TicketTag);
    getOrderListReq.setPrestatusList(this.preStatus.join());
    getOrderListReq.setIsroll(+this.roll);
    getOrderListReq.setIsrobot(Number(this.machineCollection));
    getOrderListReq.setIsreloan(Number(this.FirstsubsequentLoan));
    if (this.completeTimePicker && this.completeTimePicker[0]) {
      getOrderListReq.setCompletetimerange(
        timeFormat(this.completeTimePicker[0]) +
          " - " +
          timeFormat(this.completeTimePicker[1])
      );
    }
    let AppName:string;
      this.AppOpnList.forEach((item:any) => {
        if (item.channel==this.AppName) {
          AppName=item.channel
        }
      }); 
    getOrderListReq.setAppname(AppName);
    getOrderListReq.setPagein(
      setPage(
        this.pageIndex,
        this.pageSize,
        this.sortCondition.prop,
        this.sortCondition.order
      )
    );
    collectionServiceClient.getRemindList(
      getOrderListReq,
      {},
      (err: any, response: any) => {
        if (response) {
          const data: any = response.toObject();
          let _fuc = this.getRemindListFuc;
          handleResponse(data, _fuc);
        }
        if (err) {
          errorMsg(err);
        }
        this.isGetListActionDone = false;
      }
    );
  }
  private getListAction() {
    this.isGetListActionDone = true;
    this.pageIndex = 1;
    this.getList();
  }
  private getList() {
    if (this.page === "repay") {
      this.getRemindList();
    } else {
      this.getCollectionList();
    }
  }

  private mounted() {
    let that = this;
    that.token = localGet("token");
    this.getCollectionListParam();
    // }
    that.getList();
  }

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getList();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getList();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getList();
  }
}
